import React from "react";
import ReactECharts from 'echarts-for-react';
import { useTranslation, Trans } from 'react-i18next';

const Circular = (props) => {

    const { t, i18n } = useTranslation();

    const option = {
        tooltip: {
            trigger: 'item',
            confine: true,     // 确保 tooltip 不超出容器
        },
        legend: {
            orient: 'vertical',  // 垂直排列
            right: '2%',         // 距离右侧 5%
            top: 'center',       // 垂直居中
            formatter: (name) => {
                const dataItem = option.series[0].data.find(item => item.name === name);
                if (!dataItem) return name;
                // 2. 使用富文本（rich）设置不同样式
                return [
                    `{name|${name}}`,  // 默认颜色
                    `{value|: ${dataItem.value}}`  // 使用数据项颜色
                ].join(' ');
            },
            textStyle: {
                rich: {
                    name: {
                        color: '#333', // 名字默认颜色
                    },
                    value: {
                        color: (params) => {
                            // 动态获取对应数据的颜色
                            const dataItem = option.series[0].data.find(item => item.name === params.name);
                            return dataItem?.itemStyle?.color || '#666'; // 默认灰色
                        },
                        fontWeight: 'bold',
                    },
                },
            },
        },
        series: [
            {
                name: 'Access From',
                type: 'pie',
                center: ['25%', '50%'],  // 调整饼图位置：[水平偏移, 垂直偏移]
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 25,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: props?.data?.totalCars, name: t('carInfo.total') },
                    { value: props?.data?.hiredCars, name: t('carInfo.rented') },
                    { value: props?.data?.storageCars, name: t('carInfo.inventory') },
                    { value: props?.data?.onlineCars, name: t('carInfo.onLine') }
                ]
            }
        ]
    };

    return (
        <ReactECharts option={option} />
    )
}

export { Circular }